module.exports = __webpack_public_path__ + "static/media/IMG-20200108-WA0010.e570ea2a.jpg";